import config from "../../gatsby-config"

export const github = `https://github.com/${config.siteMetadata.social.github}`

export const linkedin = `https://linkedin.com/in/${config.siteMetadata.social.linkedin}`
